const RTL_CHAR_PATTERN = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]/;

export const isRtlText = (text?: string | null): boolean => {
  if (!text) {
    return false;
  }
  return RTL_CHAR_PATTERN.test(text);
};
